import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import itTranslations from './locales/it.json';

const resources = {
  en: {
    translation: enTranslations
  },
  it: {
    translation: itTranslations
  }
};

i18n
  .use(LanguageDetector)  // Detect user language
  .use(initReactI18next)  // Initialize react-i18next
  .init({
    resources,
    supportedLngs: ['en', 'it'],
    fallbackLng: 'en',
    load: 'languageOnly',  // Use 'en' instead of 'en-US'
    debug: false,
    detection: {
      // Keep compatibility with our UI, which stores the chosen language in localStorage.
      // i18next-browser-languagedetector defaults to `i18nextLng`, so we explicitly use `language`.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false  // React already protects from XSS
    },
    react: {
      useSuspense: false  // Prevent Suspense issues with language changes
    }
  });

export default i18n;

